"use client";import{forwardRef as t}from"react";const e=t,o=t,r=t;export{e as polymorphicForwardRef,r as staticForwardDefinedRef,o as staticForwardRef};
